import { pushBookAppointmentDataLayer } from 'util/book-appointment-datalayer'

import * as React from 'react'

import getConfig from 'next/config'

import { Selectors as AuthSelectors, State as AuthState } from '@grandvisionhq/auth'
import { CmsComponentSlot } from '@grandvisionhq/bloomreach'
import { Button } from '@grandvisionhq/common'
import { Container } from '@grandvisionhq/elements'
import { NextPage } from '@grandvisionhq/next'
import { useIntl, useSelector } from '@grandvisionhq/state'
import { compose } from '@grandvisionhq/utils'

import { withCms, withLayout } from '../cms'

import '@grandvisionhq/appointments/dist/index.css'

const { publicRuntimeConfig } = getConfig()
const gatUrl = publicRuntimeConfig?.grandvision?.gatUrl ?? ''

type InitialProps = {
  queryParams?: Record<string, string | string[] | undefined>
}

type Props = InitialProps

const BookAppointmentPage: NextPage<Props, InitialProps> = ({ queryParams = {} }) => {
  const { getLabel } = useIntl()
  const [height, setHeight] = React.useState(500)
  const auth = useSelector(AuthSelectors.getAuth)
  const userId = auth?.userId
  const loggedInState = AuthState.getLoggedInState(auth)

  const storeId = Array.isArray(queryParams.storeId) ? queryParams.storeId[0] : queryParams.storeId

  const isValidStoreId = storeId && /^\d+$/.test(storeId)
  if (!isValidStoreId) {
    console.error(`No valid storeId supplied. StoreId should be a number. Got: ${storeId}`)
  }

  if (!gatUrl) {
    console.error(`No valid GAT url supplied! Got: ${gatUrl}`)
  }

  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('message', (e) => {
        if (/https?:\/\/([a-z0-9\-]+\.)?clicrdv\.com/.test(e.origin)) {
          const { height } = typeof e.data === 'string' && JSON.parse(e.data)
          if (height !== undefined) {
            setHeight(height)
          }
        }
      })
    }
  }, [])

  React.useEffect(() => {
    pushBookAppointmentDataLayer(loggedInState, userId, storeId)
  }, [userId, loggedInState, storeId])

  const onGoBack = () => {
    window?.history.go(-1)
  }

  return (
    <>
      <CmsComponentSlot path="main/top-container" />
      <Container className="appointment">
        {gatUrl && isValidStoreId ? (
          <iframe
            className="appointment__iframe"
            style={{ height }}
            id="clicrdv-tool"
            title="clicrdv-tool"
            frameBorder={0}
            src={`${gatUrl}-${storeId}`}
          />
        ) : (
          <div className="appointment__error">
            <h3>{getLabel('appointment.errors.generic.message')}</h3>
            <Button caption={getLabel('appointment.actions.goBack')} onClick={onGoBack} />
          </div>
        )}
      </Container>
      <CmsComponentSlot path="main/bottom-container" />
    </>
  )
}

BookAppointmentPage.getInitialProps = ({ query }) => ({
  queryParams: query,
})

export default compose<Props, Props>(
  withCms(),
  withLayout({ footer: false, navigation: false })
)(BookAppointmentPage)
